import { Component, Inject, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

//* Core
import { LoadingService, SpAuthService, UserContextService } from '@core/services';
import { fadeInOut } from '@core/animations';
import * as Program from '@core/constants/program-code-constants';

//* Shared
import { Clients } from '@shared/enums';
import { ModalService } from '@shared/components/modal/modal.service';
import { take } from 'rxjs';

@Component({
  selector: 'sp-root',
  template: `
    <!--//? Timeout -->
    <sp-session-timeout> </sp-session-timeout>
    <!--//? Header -->
    <ng-container *ngIf="authIds$ | async as authIds">
      <ng-container *ngIf="userContext$ | async as userContext">
        <sp-header [userContext]="userContext" [client]="client.surepayroll"></sp-header>
      </ng-container>
    </ng-container>
    <!--//? Page Container -->
    <sp-page-content-container [isAppContainer]="true">
      <!--//* Alert -->
      <sp-alert></sp-alert>
      <!--//* Modal -->
      <sp-modal *ngIf="isModal$ | async"></sp-modal>
      <!--//* Spinner -->
      <sp-spinner *ngIf="isLoading$ | async" [@fadeInOut]></sp-spinner>
      <!--//? Component Outlet -->
      <router-outlet #page="outlet"></router-outlet>
    </sp-page-content-container>
  `,
  styles: [
    `
      :host {
        padding: 0;
        display: flex;
        flex-direction: column;
        height: 100%;
        overflow: hidden;
      }
    `,
  ],
  animations: [fadeInOut],
})
export class AppComponent {
  isLoading$ = this.loadingService.isLoading$;
  isModal$ = this.modalService.isModalOpen$;
  client = Clients;
  userContext$ = this.userContextService.userContext$;
  authIds$ = this.authService.authIds$;

  constructor(
    private loadingService: LoadingService,
    private modalService: ModalService,
    private userContextService: UserContextService,
    private authService: SpAuthService,
    @Inject(DOCUMENT) document: Document,
    renderer: Renderer2
  ) {
    this.userContext$.pipe(take(1)).subscribe(userContext => {
      const programCode = userContext.programCode.toLowerCase();
      let partner = '';
      switch (true) {
        case Program.isSureClient(programCode):
          partner = 'sp';
          break;
        case Program.isRpClient(programCode):
          partner = 'rp';
          break;
        case Program.isPxClient(programCode):
          partner = 'pxgo';
          break;
        case Program.isTrustClient(programCode):
          partner = 'sunt';
          break;
      }
      renderer.addClass(document.body, partner);
    });
  }
}
